module.exports = __webpack_public_path__ + "static/media/task3Planet4.7e1667d0.png";